import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] as const },
  },
};

const locadoras = [
  {
    nome: "LM Mobilidade",
    telefone: "0800 075 5050",
  },
  {
    nome: "Arval",
    telefone: "0800 70 27825",
  },
  {
    nome: "Localiza Meoo",
    telefone: "0800 099 1001",
    ajudaLabel: "Central de ajuda",
    ajudaUrl: "https://meooajuda.localiza.com/s/",
  },
];

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Aceena encerrou suas atividades</title>
        <meta
          name="description"
          content="A Aceena encerrou suas atividades. Clientes com contrato ativo devem contatar diretamente a locadora responsável pelo veículo."
        />
        <link rel="canonical" href="https://www.aceena.com.br" />
        <meta property="og:title" content="Aceena encerrou suas atividades" />
        <meta
          property="og:description"
          content="A Aceena encerrou suas atividades. Clientes com contrato ativo devem contatar diretamente a locadora responsável pelo veículo."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.aceena.com.br" />
        <meta property="og:locale" content="pt_BR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aceena encerrou suas atividades" />
        <meta
          name="twitter:description"
          content="A Aceena encerrou suas atividades. Clientes com contrato ativo devem contatar diretamente a locadora responsável pelo veículo."
        />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#2D395B" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <section className="pt-20 lg:pt-28 pb-12 lg:pb-16">
            <div className="container">
              <motion.div
                initial="hidden"
                animate="visible"
                variants={fadeUpVariants}
                className="max-w-3xl mx-auto text-center"
              >
                <h1 className="text-3xl lg:text-5xl font-bold text-foreground leading-tight">
                  A Aceena encerrou suas atividades
                </h1>
                <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
                  Agradecemos a todos os clientes e parceiros pela confiança ao
                  longo dessa jornada.
                </p>
              </motion.div>
            </div>
          </section>

          <section className="py-12 lg:py-16 bg-muted/30 border-y border-border">
            <div className="container">
              <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl lg:text-3xl font-bold text-foreground text-center">
                  Tenho um contrato de assinatura ativo. O que faço?
                </h2>
                <p className="mt-4 text-muted-foreground leading-relaxed text-center max-w-3xl mx-auto">
                  Seu contrato é direto com a locadora, e não com a Aceena. Para
                  qualquer assunto — manutenção, sinistro, multas, cobrança,
                  documentação ou devolução do veículo — fale diretamente com a
                  locadora responsável pelo seu carro:
                </p>

                <div className="mt-10 grid md:grid-cols-3 gap-6">
                  {locadoras.map((loc) => (
                    <div
                      key={loc.nome}
                      className="bg-card rounded-xl border border-border p-6 text-center shadow-sm"
                    >
                      <p className="font-semibold text-foreground">{loc.nome}</p>
                      <p className="mt-2 text-lg text-primary font-medium">
                        {loc.telefone}
                      </p>
                      {loc.ajudaUrl && (
                        <a
                          href={loc.ajudaUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-3 inline-block text-sm text-muted-foreground underline underline-offset-2 hover:text-foreground transition-colors"
                        >
                          {loc.ajudaLabel}
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-12 lg:py-16">
            <div className="container">
              <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-2xl lg:text-3xl font-bold text-foreground">
                  Quero renovar ou contratar uma nova assinatura
                </h2>
                <p className="mt-4 text-muted-foreground leading-relaxed">
                  Procure diretamente as locadoras do mercado. A Aceena não
                  realiza mais intermediação de contratos.
                </p>

                <p className="mt-12 text-sm text-muted-foreground">
                  Assuntos que não se enquadram acima:{" "}
                  <a
                    href="mailto:contato@aceena.com.br"
                    className="underline underline-offset-2 hover:text-foreground transition-colors"
                  >
                    contato@aceena.com.br
                  </a>
                </p>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <CookieConsentBanner />
      </div>
    </>
  );
};

export default Index;
